import { findLinkEntities } from 'medium-draft/lib/components/entities/link';
import { CompositeDecorator } from 'draft-js';
import Link from '../../../components/MediumDraft/link';
export default new CompositeDecorator([{
  strategy: findLinkEntities,
  component: Link
}]);